import Box from 'assets/components/box/Box';
import Button from 'assets/components/button/Button';
import LinkButton from 'assets/components/button/LinkButton';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import DataMap from 'assets/components/dataMap/DataMap';
import { addLog } from 'assets/components/feedback/Feedback';
import Icon from 'assets/components/icon/Icon';
import { ALL_LOCALES, getLocales } from 'assets/locales/Locale';
import Theme from 'assets/themes/Theme.Common';
import { preventDefaultBehavior } from 'assets/utils/dom/Events';
import { HttpStatus } from 'config/Api.Config';
import {
  documentTranslationDeleteApi,
  documentTranslationSaveApi,
} from 'models/localization/documentTranslation/Model.DocumentTranslation';
import { useRef, useState } from 'react';

type UploadDocumentTranslationButtonProps = {
  documentId: number;
  documentType: Utils.DocumentLocalizationType;
  translatedDocuments: Array<Model.IDocumentTranslation>;
  onFinish(): void;
};
export default function UploadDocumentTranslationButton(props: UploadDocumentTranslationButtonProps) {
  const [languageIsoCode, setLanguageIsoCode] = useState<Locale.Languages>();
  async function handleUpload(formFile: File) {
    if (languageIsoCode) {
      const uploadResponse = await documentTranslationSaveApi({
        languageIsoCode,
        formFile,
        documentId: props.documentId,
        documentType: props.documentType,
      });

      addLog({
        [uploadResponse.status !== HttpStatus.ok ? 'error' : 'success']:
          uploadResponse.message ?? (uploadResponse.status !== HttpStatus.ok ? lang.unknownError : lang.success),
      });
      props.onFinish();
    }
  }
  async function handleDelete(id: number) {
    const deleteResponse = await documentTranslationDeleteApi({
      id,
    });

    addLog({
      [deleteResponse.status !== HttpStatus.ok ? 'error' : 'success']:
        deleteResponse.message ?? (deleteResponse.status !== HttpStatus.ok ? lang.unknownError : lang.success),
    });
    props.onFinish();
  }

  const { lang } = getLocales();
  const fileInput = useRef<HTMLInputElement>();

  return (
    <>
      <input
        ref={fileInput}
        onClick={(event) => event.stopPropagation()}
        onChange={(event) => {
          preventDefaultBehavior(event);
          handleUpload(event.currentTarget.files[0]);
          event.currentTarget.value = '';
        }}
        type="file"
        accept="*"
        multiple={false}
        style={{ display: 'none' }}
      />
      <DataMap
        data={ALL_LOCALES}
        render={({ data: locale }) => {
          const translatedDoc = props.translatedDocuments.find((d) => d.languageIsoCode === locale);
          const isUploaded = locale === 'en' || !!translatedDoc;
          return (
            <Box
              style={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Icon
                class={isUploaded ? 'fas-check' : 'fas-times'}
                style={{ width: '30px', color: isUploaded ? Theme.Color.success : Theme.Color.error }}
              />
              &nbsp;
              {lang[locale]}
              {locale !== 'en' && (
                <Button
                  class={ThemeButtonCircle}
                  media={<Icon class={translatedDoc ? 'fas-trash' : 'fas-upload'} />}
                  htmlElementProps={{
                    title: translatedDoc ? `${lang.delete}: ${translatedDoc.mediaFile?.name}` : lang.upload,
                  }}
                  onClick={() => {
                    if (translatedDoc) {
                      handleDelete(translatedDoc.id);
                    } else {
                      setLanguageIsoCode(locale);
                      fileInput.current.click();
                    }
                  }}
                />
              )}
              {locale !== 'en' && (
                <LinkButton
                  class={ThemeButtonCircle}
                  url={translatedDoc?.mediaFile?.url}
                  media={<Icon class="fas-download" />}
                  target="_blank"
                  disabled={!translatedDoc}
                  htmlElementProps={{ title: lang.download }}
                />
              )}
            </Box>
          );
        }}
      />
    </>
  );
}
